module.exports = __webpack_public_path__ + "static/media/car_splash_alternative.3b4206f9.png";